export default __webpack_public_path__ + "static/media/image22tum.8ee3daa2.jpg";